import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-f', 'LetterF', [["path",{"d":"M17 4h-10v16"}],["path",{"d":"M7 12l8 0"}]]);